<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class="titleDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body dialog-content">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')" />
          <span>提示</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <p class="title">请验证手机号后再继续操作</p>
      </div>
      <div class="d-footer btns">
        <span class="app-but primaryBtn" @click="confirm">去验证</span>
        <span class="plainBtn" @click="handleClose">取消</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VerifyPhone',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style lang="scss">
.titleDialog {
  margin-top: 0 !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 20px 24px 24px 24px;
  }

  .d-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;

      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }

    .close_img {
      cursor: pointer;
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .d-content {
    margin: 32px 0 24px 0;
    font-size: 18px;
    .title {
      font-size: 16px; //设计图有问题18 ——> 16
      line-height: 24px;
      text-align: center;
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }

    .txt {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      span {
        line-height: 22px;
      }
    }
  }

  .d-footer {
    display: flex;
    justify-content: center;
  }
  .primaryBtn {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btns {
    span {
      width: 110px;
      line-height: 36px;
      height: 36px;
      font-weight: 500;
      margin: 0 8px;
    }
  }
}
</style>
